import { Controller } from "@hotwired/stimulus"
import ValueParser from "../../utils/value_parser"

export default class extends Controller {
  static targets = ["input", "overall", "button"]

  connect() {
    app.tracker = this
    this.updateOverallTotal()
  }

  updateOverallTotal() {
    let total = this.calculateOverallTotal()
    this.overallTarget.innerText = total + '%'

    if (total != 100) {
      this.overallTarget.classList.add('text-red-500')
      this.buttonTarget.disabled = true
      this.buttonTarget.classList.add('opacity-50')
      this.buttonTarget.classList.add('cursor-not-allowed')
    } else {
      this.overallTarget.classList.remove('text-red-500')
      this.buttonTarget.disabled = false
      this.buttonTarget.classList.remove('opacity-50')
      this.buttonTarget.classList.remove('cursor-not-allowed')
    }
  }

  calculateOverallTotal(){
    let total = 0

    this.inputTargets.forEach((input) => {
      let value = parseFloat(input.value, 10)

      if (!isNaN(value)) {
        total += value
      }
    })

    return total.toFixed(2)
  }
}
